import axios, { AxiosRequestConfig } from "axios";
import { LessonReservable, LessonStudent, LessonStudio, LessonTeacher, LessonUnreservable, ObjectToLessonReservable, ObjectToLessonReservableProps, ObjectToLessonStudio, ObjectToLessonStudioProps, ObjectToLessonUnreservable, ObjectToLessonUnreservableProps } from "../Objects/OnlineLesson";
import { ApiError } from "./ApiError";
import { WeekType } from "../Helper/Week"
import { Time } from "../Helper/Time";
import { format } from "date-fns";

axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = 'X-CSRF-Token';

export interface getTeacherListProps {
    limit: number
    offset: number
    student_id?: number
}
export interface LessonTeachers {
    rows: number,
    pagenum: number,
    list: LessonTeacher[]
}
/**
 * getTeacherList
 * @returns string[]
 */
export const getTeacherList = async ({
    limit,
    offset,
    student_id
}: getTeacherListProps, config?: AxiosRequestConfig): Promise<LessonTeachers> => {
    try {
        let params = new URLSearchParams()
        params.append('limit', limit.toString())
        params.append('offset', offset.toString())
        if (student_id) {
            params.append('student_id', student_id.toString())
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/get_teacher_list',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return {
            rows: res.data.rows,
            pagenum: Math.ceil(parseInt(res.data.rows) / limit),
            list: res.data.list
        }
    } catch (error) {
        throw error
    }
}

export interface getStudentListProps {
    limit: number
    offset: number
    teacher_id?: number
}
export interface LessonStudents {
    rows: number,
    pagenum: number,
    list: LessonStudent[]
}
/**
 * getStudentList
 * @param param0 
 * @returns 
 */
export const getStudentList = async ({
    limit,
    offset,
    teacher_id
}: getStudentListProps, config?: AxiosRequestConfig): Promise<LessonStudents> => {
    try {
        let params = new URLSearchParams()
        params.append('limit', limit.toString())
        params.append('offset', offset.toString())
        if (teacher_id) {
            params.append('teacher_id', teacher_id.toString())
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/get_student_list',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return {
            rows: res.data.rows,
            pagenum: Math.ceil(parseInt(res.data.rows) / limit),
            list: res.data.list
        }
    } catch (error) {
        throw error
    }
}

/**
 * RegisterTeacher
 * @param ctm_id 
 * @returns teacher_id: number
 */
export const RegisterTeacher = async (ctm_id: number, config?: AxiosRequestConfig): Promise<number> => {
    try {
        let params = new URLSearchParams()
        params.append('ctm_id', ctm_id.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/register_teacher',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return res.data.teacher_id
    } catch (error) {
        throw error
    }
}

/**
 * UnregisterTeacher
 * @param teacher_id 
 */
export const UnregisterTeacher = async (teacher_id: number, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append('teacher_id', teacher_id.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/unregister_teacher',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

/**
 * getTeacherData
 * @param teacher_id 
 */
export const getTeacherData = async (teacher_id: number, config?: AxiosRequestConfig): Promise<LessonTeacher> => {
    try {
        let params = new URLSearchParams()
        params.append('teacher_id', teacher_id.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/get_teacher_data',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return res.data.teacher_data
    } catch (error) {
        throw error
    }
}

export interface RegisterStudentProps {
    ctm_id?: number
    teacher_id?: number
    student_id?: number
}
/**
 * RegisterStudent
 * @param param0 
 * @returns 
 */
export const RegisterStudent = async ({
    ctm_id,
    teacher_id,
    student_id
}: RegisterStudentProps, config?: AxiosRequestConfig): Promise<number> => {
    try {
        let params = new URLSearchParams()
        if (ctm_id) {
            params.append('ctm_id', ctm_id.toString())
        }
        if (teacher_id) {
            params.append('teacher_id', teacher_id.toString())
        }
        if (student_id) {
            params.append('student_id', student_id.toString())
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/register_student',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return res.data.student_id
    } catch (error) {
        throw error
    }
}

export interface UnregisterStudentProps {
    teacher_id: number
    student_id: number
}
/**
 * UnregisterStudent
 * @param param0 
 * @returns 
 */
export const UnregisterStudent = async ({
    teacher_id,
    student_id
}: UnregisterStudentProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append('teacher_id', teacher_id.toString())
        params.append('student_id', student_id.toString())
        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/unregister_student',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return res.data.student_id
    } catch (error) {
        throw error
    }
}

export interface getLessonReservableListProps {
    limit: number
    offset: number
    teacher_id: number
}
export interface LessonReservables {
    rows: number
    pagenum: number
    list: LessonReservable[]
}
/**
 * getLessonReservableList
 * @param param0 
 * @returns 
 */
export const getLessonReservableList = async ({
    limit,
    offset,
    teacher_id
}: getLessonReservableListProps, config?: AxiosRequestConfig): Promise<LessonReservables> => {
    try {
        let params = new URLSearchParams()
        params.append('limit', limit.toString())
        params.append('offset', offset.toString())
        params.append('teacher_id', teacher_id.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/get_lesson_reservable_list',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return {
            rows: res.data.rows,
            pagenum: Math.ceil(parseInt(res.data.rows) / limit),
            list: res.data.list.map((item: ObjectToLessonReservableProps)=>{
                return ObjectToLessonReservable(item)
            })
        }
    } catch (error) {
        throw error
    }
}

export interface getLessonUnreservableListProps {
    limit: number
    offset: number
    teacher_id: number
}
export interface LessonUnreservables {
    rows: number
    pagenum: number
    list: LessonUnreservable[]
}
/**
 * getLessonUnreservableList
 * @param param0 
 * @returns 
 */
export const getLessonUnreservableList = async ({
    limit,
    offset,
    teacher_id
}: getLessonUnreservableListProps, config?: AxiosRequestConfig): Promise<LessonUnreservables> => {
    try {
        let params = new URLSearchParams()
        params.append('limit', limit.toString())
        params.append('offset', offset.toString())
        params.append('teacher_id', teacher_id.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/get_lesson_unreservable_list',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return {
            rows: res.data.rows,
            pagenum: Math.ceil(parseInt(res.data.rows) / limit),
            list: res.data.list.map((item: ObjectToLessonUnreservableProps)=>{
                return ObjectToLessonUnreservable(item)
            })
        }
    } catch (error) {
        throw error
    }
}

export interface addLessonReservableProps {
    teacher_id: number
    week_conditions: WeekType
    start: Time
    end: Time
    start_apply?: Date
    end_apply?: Date
}
export const addLessonReservable = async ({
    teacher_id,
    week_conditions,
    start,
    end,
    start_apply,
    end_apply,
}: addLessonReservableProps, config?: AxiosRequestConfig): Promise<number> => {
    try {
        let params = new URLSearchParams()
        params.append('teacher_id', teacher_id.toString())
        params.append('week_conditions', week_conditions)
        params.append('start', start.toString())
        params.append('end', end.toString())
        if( start_apply ) {
            params.append('start_apply', format(start_apply, "yyyy-MM-dd HH:mm:ss"))
        }
        if( end_apply ) {
            params.append('end_apply', format(end_apply, "yyyy-MM-dd HH:mm:ss"))
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/add_lesson_reservable',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return res.data.lrvable_id
    } catch (error) {
        throw error
    }
}

export interface editLessonReservableProps {
    lrvable_id: number
    teacher_id: number
    week_conditions: WeekType
    start: Time
    end: Time
    start_apply?: Date | null
    end_apply?: Date | null
}
export const editLessonReservable = async ({
    lrvable_id,
    teacher_id,
    week_conditions,
    start,
    end,
    start_apply,
    end_apply,
}: editLessonReservableProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append('lrvable_id', lrvable_id.toString())
        params.append('teacher_id', teacher_id.toString())
        params.append('week_conditions', week_conditions)
        params.append('start', start.toString())
        params.append('end', end.toString())
        if( start_apply ) {
            params.append('start_apply', format(start_apply, "yyyy-MM-dd HH:mm:ss"))
        }
        if( end_apply ) {
            params.append('end_apply', format(end_apply, "yyyy-MM-dd HH:mm:ss"))
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/edit_lesson_reservable',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface addLessonUnreservableProps {
    teacher_id: number
    lurvable_date?: Date | null
    start?: Time | null
    end?: Time | null
}
export const addLessonUnreservable = async ({
    teacher_id,
    lurvable_date,
    start,
    end,
}: addLessonUnreservableProps, config?: AxiosRequestConfig): Promise<number> => {
    try {
        let params = new URLSearchParams()
        params.append('teacher_id', teacher_id.toString())
        if(lurvable_date) {
            params.append('lurvable_date', format(lurvable_date, "yyyy-MM-dd"))
        }
        if(start) {
            params.append('start', start.toString())
        }
        if(end) {
            params.append('end', end.toString())
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/add_lesson_unreservable',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return res.data.lurvable_id
    } catch (error) {
        throw error
    }
}

export interface editLessonUneservableProps {
    lurvable_id: number
    teacher_id: number
    lurvable_date?: Date | null
    start?: Time | null
    end?: Time | null
}
export const editLessonUnreservable = async ({
    lurvable_id,
    teacher_id,
    lurvable_date,
    start,
    end,
}: editLessonUneservableProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append('lurvable_id', lurvable_id.toString())
        params.append('teacher_id', teacher_id.toString())
        if(lurvable_date) {
            params.append('lurvable_date', format(lurvable_date, "yyyy-MM-dd"))
        }
        if( start ) {
            params.append('start', start.toString())
        }
        if( end ) {
            params.append('end', end.toString())
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/edit_lesson_unreservable',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface addLessonStudioProps {
    std_id: number
    start_apply?: Date
    end_apply?: Date
}
export const addLessonStudio = async ({
    std_id,
    start_apply,
    end_apply,
}: addLessonStudioProps, config?: AxiosRequestConfig): Promise<number> => {
    try {
        let params = new URLSearchParams()
        params.append('std_id', std_id.toString())
        if(start_apply) {
            params.append('start_apply', format(start_apply, "yyyy-MM-dd"))
        }
        if(end_apply) {
            params.append('end_apply', format(end_apply, "yyyy-MM-dd"))
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/add_lesson_studio',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return res.data.lstd_id
    } catch (error) {
        throw error
    }
}

export interface editLessonStudioProps {
    lstd_id: number
    end_apply?: Date
}
export const editLessonStudio = async ({
    lstd_id,
    end_apply,
}: editLessonStudioProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append('lstd_id', lstd_id.toString())
        if(end_apply) {
            params.append('end_apply', format(end_apply, "yyyy-MM-dd"))
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/edit_lesson_studio',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export interface deleteLessonStudioProps {
    lstd_id: number
}
export const deleteLessonStudio = async ({
    lstd_id,
}: deleteLessonStudioProps, config?: AxiosRequestConfig): Promise<void> => {
    try {
        let params = new URLSearchParams()
        params.append('lstd_id', lstd_id.toString())

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/delete_lesson_studio',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
    } catch (error) {
        throw error
    }
}

export const LessonStudioListType = {
    all: "all",
    apply: "apply",
    default: "default"
} as const;
export type LessonStudioListType = typeof LessonStudioListType[keyof typeof LessonStudioListType] 
export interface getLessonStudioListProps {
    limit: number
    offset: number
    str_id: number
    type?: LessonStudioListType
}
export interface LessonStudioList {
    rows: number
    pagenum: number
    list: LessonStudio[]
}
/**
 * オンラインレッスン利用可能スタジオ一覧を取得
 * @param param0 
 * @returns 
 */
export const getLessonStudioList = async ({
    limit,
    offset,
    str_id,
    type
}: getLessonStudioListProps, config?: AxiosRequestConfig): Promise<LessonStudioList> => {
    try {
        let params = new URLSearchParams()
        params.append('limit', limit.toString())
        params.append('offset', offset.toString())
        params.append('str_id', str_id.toString())
        if(type) {
            params.append('type', type)
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'online_lesson/get_lesson_studio_list',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return {
            rows: res.data.rows,
            pagenum: Math.ceil(parseInt(res.data.rows) / limit),
            list: res.data.list.map((item: ObjectToLessonStudioProps)=>{
                return ObjectToLessonStudio(item)
            })
        }
    } catch (error) {
        throw error
    }
}